<template>
  <nav>
    <v-app-bar
      tile flat app absolute
      color="white"
      min-width="100%"
    >
      <!-- <a 
        href="/"
        class="d-flex align-center"
        style="text-decoration: none"
      > -->
      <!-- <nuxt-link :to="{name: 'index'}"> -->
      <!-- <nuxt-link to="/"> -->
        <v-img
          contain
          :src="getImg(logo)"
          class='ml-6'
          :class="{
            'justify-left': $vuetify.breakpoint.mdAndUp,
            'justify-center': $vuetify.breakpoint.smAndDown,
          }"
          max-height='80'
          max-width="200"
        />
      <!-- </nuxt-link> -->
      <!-- </a> -->
      <!-- <v-icon class="grey--text text--lighten-3">mdi-circle-medium</v-icon>
      <div class="grey--text text--lighten-3 title font-weight-medium"><span class="barlow">Blog</span></div> -->
      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <v-btn
        text
        class="transparent black--text"
        href="https://institutoaltoimpacto.com.br/blog"
        target="_blank"
      >
        Blog
      </v-btn>
      <v-btn
        text
        class="transparent black--text ml-2"
        @click="$vuetify.goTo('#servicos')"
      >
        Serviços
      </v-btn>
      <v-btn
        outlined
        class="primary--text ml-2"
        @click="$vuetify.goTo('#treinamentos')"
      >
        Treinamentos
      </v-btn>
      <!-- <v-toolbar-items class="hidden-sm-and-down mr-6">
        
      </v-toolbar-items> -->
    </v-app-bar>
  </nav>
</template>

<script>
export default {

  data: () => ({
    logo: 'logo.png',
    botoes: [
      // {
      //   icone: 'mdi-whatsapp',
      //   url: ''
      // },
      
      {
        icone: 'mdi-instagram',
        url: 'https://www.instagram.com/madeiraplasticaecomax/'
      },
      {
        icone: 'mdi-facebook',
        url: 'https://www.facebook.com/madeiraplasticaecomax/'
      },
      {
        icone: 'mdi-linkedin',
        url: 'https://www.linkedin.com/company/madeiraplasticaecomax'
      },
    ],
  }),
  methods: {
    getImg(i) {
      return require('@/assets/img/'+i)
    },
  }
}
</script>